// PROP-TNT-REL-CHK
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import IsTypeOfPayment from '../rules/IsTypeOfPayment';

class MilestonePaymentAcknowledgementRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    return IsTypeOfPayment.setType('milestone').evaluate(data)
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new MilestonePaymentAcknowledgementRuleset();
